module.exports = __webpack_public_path__ + "img/lg_ring_y_c_0_1@3x.ddfb9438.png";